import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";

import WizardDetailsPanelSummary from "../detailsPanel/WizardDetailsPanelSummary.jsx";
import RequiredOptionPanelSummary from "../requiredOptionPanel/RequiredOptionPanelSummary.jsx";
import RegionPanelSummary from "../regionPanel/RegionPanelSummary.jsx";
import ResourcePanelSummary from "../resourcePanel/ResourcePanelSummary.jsx";
import OTPPanelSummary from "../OTPPanel/OTPPanelSummary.jsx";
import SSHPanelSummary from "../SSHPanel/SSHPanelSummary.jsx";
import CIDRPanelSummary from "../CIDRPanel/CIDRPanelSummary.jsx";

import { PANEL_TYPES } from "../../../state/reducers/projectWizard/projectWizardConstants.js";
import { AT_TYPES } from "../../../constants/entity.js";

class SummaryPanelMap extends PureComponent {
  static propTypes = {
    type: PropTypes.string.isRequired,
    provider: PropTypes.object,
    providersList: PropTypes.array.isRequired,
    regionsList: PropTypes.array.isRequired,
    zonesList: PropTypes.array.isRequired,
    configCopyKey: PropTypes.string
  };

  getCopyKeys = key => {
    const { configCopyKey } = this.props;

    if (!key) return null;

    const keys = {
      copyKey: `project_wizard.${key}`
    };

    if (configCopyKey) {
      keys.configCopyKey = `${configCopyKey}.${key}`;
    }

    return keys;
  };

  getPanelMap = () => {
    const { provider, providersList, region, regionsList, zone, zonesList } =
      this.props;

    return {
      [PANEL_TYPES.DETAILS]: {
        component: WizardDetailsPanelSummary,
        panelProps: {
          ...this.getCopyKeys("details_panel")
        }
      },
      [PANEL_TYPES.PROVIDER]: {
        component: RequiredOptionPanelSummary,
        panelProps: {
          name: "provider",
          options: providersList,
          selected: provider,
          ...this.getCopyKeys("provider_panel")
        }
      },
      [PANEL_TYPES.REGION]: {
        component: RegionPanelSummary,
        panelProps: {
          name: "region",
          regionOptions: regionsList,
          zoneOptions: zonesList,
          ...this.getCopyKeys("region_panel")
        }
      },
      [PANEL_TYPES.WORKSTATION]: {
        component: ResourcePanelSummary,
        panelProps: {
          resourceType: AT_TYPES.WORKSTATION,
          enableMultiples: true,
          ...this.getCopyKeys("workstation_panel")
        }
      },
      [PANEL_TYPES.STORAGE]: {
        component: ResourcePanelSummary,
        panelProps: {
          resourceType: AT_TYPES.CONTAINER,
          ...this.getCopyKeys("storage_panel")
        }
      },
      [PANEL_TYPES.RENDER_MANAGER]: {
        component: ResourcePanelSummary,
        panelProps: {
          resourceType: AT_TYPES.DATABASE,
          ...this.getCopyKeys("render_manager_panel")
        }
      },
      [PANEL_TYPES.NODE]: {
        component: ResourcePanelSummary,
        panelProps: {
          resourceType: AT_TYPES.NODE,
          enableMultiples: true,
          ...this.getCopyKeys("node_panel")
        }
      },
      [PANEL_TYPES.SNOWFLAKE]: {
        component: ResourcePanelSummary,
        panelProps: {
          resourceType: AT_TYPES.SNOWFLAKE,
          ...this.getCopyKeys("snowflake_panel")
        }
      },
      [PANEL_TYPES.OTP]: {
        component: OTPPanelSummary,
        panelProps: {
          name: "requiresUserVerification",
          ...this.getCopyKeys("otp_panel")
        }
      },
      [PANEL_TYPES.SSH]: {
        component: SSHPanelSummary,
        panelProps: {
          resourceType: AT_TYPES.SSH_KEY,
          ...this.getCopyKeys("ssh_panel")
        }
      },
      [PANEL_TYPES.CIDR]: {
        component: CIDRPanelSummary,
        panelProps: {
          ...this.getCopyKeys("cidr_panel")
        }
      },
      [PANEL_TYPES.DISPLAY_GATEWAY]: {
        component: ResourcePanelSummary,
        panelProps: {
          resourceType: AT_TYPES.DISPLAY_GATEWAY,
          ...this.getCopyKeys("display_gateway_panel")
        }
      },
      [PANEL_TYPES.VPN_GATEWAY]: {
        component: ResourcePanelSummary,
        panelProps: {
          resourceType: AT_TYPES.VPN_GATEWAY,
          ...this.getCopyKeys("vpn_panel")
        }
      }
    };
  };

  render() {
    const { type, ...props } = this.props;

    const panelMap = this.getPanelMap()[type];

    if (!panelMap) return <p>Requested panel not found.</p>;

    const Panel = panelMap.component;
    const panelProps = panelMap.panelProps;

    return <Panel {...props} {...panelProps} />;
  }
}

export default SummaryPanelMap;
